const o = {
  refetchOnMount: !1,
  refetchOnReconnect: !1,
  refetchOnWindowFocus: !1
}, m = (n) => (c) => ({
  gcTime: c,
  staleTime: c,
  retry: 2,
  refetchOnMount: !0,
  refetchOnReconnect: n,
  refetchOnWindowFocus: n
}), e = {
  "7d": 6048e5,
  "3d": 2592e5,
  "1d": 864e5,
  "6h": 216e5,
  "1h": 36e5,
  "30m": 18e5,
  "15m": 9e5,
  "10m": 6e5,
  "5m": 3e5,
  "3m": 18e4,
  "1m": 6e4,
  "30s": 3e4,
  "15s": 15e3,
  "5s": 5e3,
  "3s": 3e3,
  "1s": 1e3
}, d = [""], h = () => {
}, s = m(!0), i = {
  "7d": s(e["7d"]),
  "3d": s(e["3d"]),
  "1d": s(e["1d"]),
  "6h": s(e["6h"]),
  "1h": s(e["1h"]),
  "30m": s(e["30m"]),
  "15m": s(e["15m"]),
  "10m": s(e["10m"]),
  "5m": s(e["5m"]),
  "3m": s(e["3m"]),
  "1m": s(e["1m"]),
  "30s": s(e["30s"]),
  "15s": s(e["15s"]),
  "3s": s(e["3s"]),
  0: s(0)
}, t = m(!1), r = {
  "7d": t(e["7d"]),
  "3d": t(e["3d"]),
  "1d": t(e["1d"]),
  "6h": t(e["6h"]),
  "1h": t(e["1h"]),
  "30m": t(e["30m"]),
  "15m": t(e["15m"]),
  "10m": t(e["10m"]),
  "5m": t(e["5m"]),
  "3m": t(e["3m"]),
  "1m": t(e["1m"]),
  "30s": t(e["30s"]),
  "15s": t(e["15s"]),
  "3s": t(e["3s"]),
  0: t(0)
}, O = (n = 0) => ({
  ...m(!1)(n),
  refetchOnReconnect: !0
});
export {
  i as activeOptions,
  O as baseBraidOptions,
  o as disabledFetchOptions,
  d as emptyCacheKey,
  h as emptyFn,
  s as getActiveOptions,
  t as getInactiveOptions,
  r as inactiveOptions,
  e as milliseconds
};
